/**
 * SubmittedDateFilterBar Component
 * Filter bar for submitted date with on/after/before operators
 */

import React from 'react';
import { DatePicker, Select, Space } from 'antd';
import { colors, spacing } from '../../../theme/designTokens';

function SubmittedDateFilterBar({ dateFilter, onDateFilterChange }) {
  const { operator = 'on', date } = dateFilter || {};

  const handleOperatorChange = (newOperator) => {
    onDateFilterChange({ operator: newOperator, date });
  };

  const handleDateChange = (newDate) => {
    onDateFilterChange({ operator, date: newDate });
  };

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: spacing.md,
      }}
    >
      <span style={{ fontWeight: 500, color: colors.text.primary, whiteSpace: 'nowrap' }}>
        Submitted:
      </span>
      <Select
        value={operator}
        onChange={handleOperatorChange}
        style={{ minWidth: 95 }}
        options={[
          { label: 'On', value: 'on' },
          { label: 'After', value: 'after' },
          { label: 'Before', value: 'before' },
        ]}
      />
      <DatePicker
        value={date}
        onChange={handleDateChange}
        style={{ width: 200 }}
        format="YYYY-MM-DD"
        placeholder="Select date"
        allowClear
      />
    </div>
  );
}

export default SubmittedDateFilterBar;
